import styles from './DateSelector.module.scss';

function toDateInputValue(d) {
  if (d == null || d === '') return '';
  if (typeof d === 'string' && /^\d{4}-\d{2}-\d{2}$/.test(d)) return d;

  const date = new Date(d);
  if (Number.isNaN(date.getTime())) return '';
  const tzOffset = date.getTimezoneOffset();
  const local = new Date(date.getTime() - tzOffset * 60000);
  return local.toISOString().slice(0, 10);
}

export default function DefaultDateSelector({
  value,
  onChange,
  className,
  type = 'date',
  min = null,
  max,
  clearable = false,
  onClear = () => {},
}) {
  const v = toDateInputValue(value);

  return (
    <div
      style={{ display: 'flex', alignItems: 'center', gap: 4, width: '100%' }}
    >
      <input
        type={type}
        value={v}
        onChange={onChange}
        className={!!v ? styles.defaultDateSelector : styles.empty}
        min={toDateInputValue(min) || undefined}
        max={toDateInputValue(max) || undefined}
        style={{ flex: 1, minWidth: 0 }}
      />
      {clearable && !!v && (
        <button
          type="button"
          onClick={() => onChange(null)}
          style={{
            background: 'none',
            border: 'none',
            cursor: 'pointer',
            padding: '0 2px',
            color: '#999',
            fontSize: '1.2rem',
            lineHeight: 1,
            flexShrink: 0,
          }}
          aria-label="Clear date"
        >
          ×
        </button>
      )}
    </div>
  );
}
